import React, { useState, useEffect, useImperativeHandle } from 'react'
import axios from 'axios'
import Decimal from 'decimal.js';
import { message, Row, Col, Typography, Button, Popconfirm, Pagination, Spin } from 'antd'
import { IconDelete, IconEdit } from './../../../Widgets/Iconos';

//modales
import ModalRegistroProducto from './../ModalRegistroProducto';

const { Text } = Typography

/**
 * @method AlmacenProductosList
 * @description Componente para listar los productos en un almacén específico.
 */
const AlmacenProductosList = ({
    cliente_id,
    inventario_id,
    almacen_id,
    search,
    onEdit,
    updateAlmacen,
    ref,
}) => {

    const [loading, setLoading] = useState(false)
    const [productos, setProductos] = useState([])
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)

    const [infoModal, setInfoModal] = useState({
        visible: false,
        inventario_producto_id: null,
        cantidad: 1,
    })

    useEffect(() => {
        getAlmacenProductos()
    }, [cliente_id, inventario_id, almacen_id, search])

    //El metodo getAlmacenProductos debe de ser accesible desde el componente padre para actualizar la lista despues de agregar o editar un producto
   //usando useImperativeHandle en el componente padre

    useImperativeHandle(ref, () => ({
        getAlmacenProductos
    }), [])


    //Obtiene la lista de productos en el almacén
    const getAlmacenProductos = async (page, limit) => {
        setLoading(true)
        try {
            const {data} = await axios.get('/vmi/almacenes-productos', {
                params: {
                    cliente_id,
                    inventario_id,
                    almacen_id,
                    search,
                    limit,
                    page,
                }
            })
            
            setProductos(data?.data || [])
            setTotal(data?.total || 0)
        } catch (error) {
            console.error('Error fetching almacen productos:', error)
            message.error('Error al obtener los productos del almacén.')
        } finally {
            setLoading(false)
        }
    }

    //Elimina un producto del almacén
    const deleteAlmacenProducto = async (almacen_producto_id) => {
        try {
            await axios.post('/almacenes/productos/delete', { id: almacen_producto_id })
            message.success('¡Producto de Almacén eliminado!')
            getAlmacenProductos()
            if(updateAlmacen) updateAlmacen()
        } catch (error) {
            message.error('¡No se pudo eliminar el Producto de Almacén!')
            console.log(error)
        }
    }

    const handleCloseModal = () => {
        setInfoModal({
            visible: false,
            inventario_producto_id: null,
            cantidad: 1,
        })
        getAlmacenProductos()
        if(updateAlmacen) updateAlmacen()
    }

    return (
        <Spin spinning={loading}>
            <Row className="header-table" style={{ marginBottom: '1rem' }}>
                <Col span={4} className="center">
                    <Text strong>NP. Fabricante</Text>
                </Col>
                <Col span={4} className="center">
                    <Text strong>NP. Cliente</Text>
                </Col>
                <Col span={4} className="center">
                    <Text strong>Ubicación</Text>
                </Col>
                <Col span={2} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text strong>Cantidad</Text>
                </Col>
                <Col span={3} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text strong>Precio Unit.</Text>
                </Col>
                <Col span={3} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text strong>Valor Total</Text>
                </Col>
                <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                    <Text strong>Acciones</Text>
                </Col>
            </Row>
            {
                productos.map(({_id, producto_id, inventario_producto_id, ubicacion, cantidad, precio}) => (
                    <Row key={_id}>
                        <Col span={4} className="center">
                            <Text ellipsis>{producto_id?.np_fabricante}</Text>
                        </Col>
                        <Col span={4} className="center">
                            <Text ellipsis>{inventario_producto_id?.np_cliente}</Text>
                        </Col>
                        <Col span={4} className="center">
                            <Text className="text-gray">{ubicacion}</Text>
                        </Col>
                        <Col span={2} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                            <Text className="text-gray">{cantidad}</Text>
                        </Col>
                        <Col span={3} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                            <Text className="text-gray">$ {inventario_producto_id?.precio?.toMoney(true) ?? 0}</Text>
                        </Col>
                        <Col span={3} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                            <Text className="text-gray">$ {(Decimal(inventario_producto_id?.precio ?? 0).times(cantidad).toDecimalPlaces(2).toNumber()).toMoney(true)}</Text>
                        </Col>
                        <Col span={4} className="flex-right" style={{ paddingRight: '1.5rem' }}>
                            <Button
                                type="primary"
                                style={{ marginRight: "8px" }}
                                icon={<IconEdit />}
                                title="Editar"
                                onClick={() => setInfoModal({ visible: true, inventario_producto_id: inventario_producto_id?._id, cantidad })}
                            />
                            
                            <Popconfirm
                                placement="topRight"
                                title="¿Deseas eliminar este producto del almacen?"
                                okText="Si"
                                cancelText="No"
                                onConfirm={() => deleteAlmacenProducto(_id)}
                            >
                                <Button
                                    type="primary"
                                    icon={<IconDelete />}
                                    title="Eliminar"
                                    danger
                                />
                            </Popconfirm>
                        </Col>
                    </Row>
                ))
            }
            <Pagination
                className='mt-2 mb-2'
                size='small'
                current={page}
                pageSize={limit}
                total={total}
                onChange={(page, pageSize) => {
                    setPage(page)
                    setLimit(pageSize)
                    getAlmacenProductos(page, pageSize)
                }}
            />
            <ModalRegistroProducto
                cliente_id={cliente_id}
                inventario_id={inventario_id}

                id={infoModal.inventario_producto_id}
                cantidad={infoModal.cantidad}
                visible={infoModal.visible}

                onSuccess={handleCloseModal}
                onClose={handleCloseModal}
            />
        </Spin>
    )
}

export default AlmacenProductosList
